import { render, staticRenderFns } from "./Scene15.vue?vue&type=template&id=1073fc3f&scoped=true"
import script from "./Scene15.vue?vue&type=script&lang=js"
export * from "./Scene15.vue?vue&type=script&lang=js"
import style0 from "./Scene15.vue?vue&type=style&index=0&id=1073fc3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1073fc3f",
  null
  
)

export default component.exports